import { useQuery } from "react-query";
import { getInstantMessagesList } from "../api";
import { API_KEY_GET_INSTANT_MESSAGES_LIST } from "../helpers";

export const useGetInstantMessagesList = (params) => {
  return useQuery([API_KEY_GET_INSTANT_MESSAGES_LIST, params], () =>
    getInstantMessagesList(params)
  );
};
